import {
  FETCHING_CUSTOM_FIELDS, FETCHING_CUSTOM_FIELDS_SUCCEEDED, FETCHING_CUSTOM_FIELDS_FAILED,
  DELETING_CUSTOM_FIELD, DELETING_CUSTOM_FIELD_SUCCEEDED, DELETING_CUSTOM_FIELD_FAILED,
  FETCHING_CUSTOM_FIELD, FETCHING_CUSTOM_FIELD_SUCCEEDED, FETCHING_CUSTOM_FIELD_FAILED,
  FETCHING_PAPERFLITE_CUSTOM_FIELDS, FETCHING_PAPERFLITE_CUSTOM_FIELDS_SUCCEEDED, FETCHING_PAPERFLITE_CUSTOM_FIELDS_FAILED,
  FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC, FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_SUCCEEDED, FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_FAILED,
  CREATE_CUSTOM_FIELD, CREATING_CUSTOM_FIELD_SUCCEEDED, CREATING_CUSTOM_FIELD_FAILED,
  CREATE_CUSTOM_FIELD_FROM_PAPERFLITE, CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_SUCCEEDED, CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_FAILED,
  UPDATE_CUSTOM_FIELD, UPDATING_CUSTOM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FIELD_FAILED,INVALIDATE_CUSTOM_FIELDS
} from 'constants/actionTypes';
  
import _ from 'lodash';
  
const initialState = {
  loading: false,
  deleting: false,
  creating: false,
  updating: false,
  invalidated: false,
  currentField: null,
  items: [],
  errors: null
};

function fieldsReducer(state = initialState, action) {
  switch (action.type) {

    case FETCHING_CUSTOM_FIELDS: {
      return {
        ...state,
        loading: true,
        invalidated: true
      }
    }
  
    case FETCHING_CUSTOM_FIELDS_SUCCEEDED: {
      const records = action.payload.length > 0 ? action.payload : [];
      let items = records;

      if(records.length > 0) {
        items = [...state.items, ...records];
        items = _.uniqBy(items, 'id');
      }
  
      return {
        ...state,
        loading: false,
        invalidated: false,
        items: items
      }
    }
  
    case FETCHING_CUSTOM_FIELDS_FAILED: {
      var error = action.payload;
    
      return {
        ...state,
        loading: false,
        invalidated: false,
        error: error
      }
    }

    case DELETING_CUSTOM_FIELD: {
      return {
        ...state,
        deleting: true
      }
    }
  
    case DELETING_CUSTOM_FIELD_SUCCEEDED: {
      const deletedRecord = action.payload;
      let newRecords = [];

      if(deletedRecord) {
        newRecords = state.items.filter((item)=> item.id != deletedRecord.id);
      }
  
      return {
        ...state,
        loading: false,
        invalidated: false,
        items: newRecords,
        currentField: null
      }
    }
  
    case DELETING_CUSTOM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        deleting: false,
        error: error
      }
    }

    case FETCHING_CUSTOM_FIELD: {
      return {
        ...state,
        invalidated: true
      }
    }
  
    case FETCHING_CUSTOM_FIELD_SUCCEEDED: {
      let record = action.payload;

      if(record && !record.type){
        record = {
          ...record, 
          type: 'list_field'
        }
      }
  
      return {
        ...state,
        invalidated: false,
        currentField: record
      }
    }
  
    case FETCHING_CUSTOM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        invalidated: false,
        error: error
      }
    }

    case FETCHING_PAPERFLITE_CUSTOM_FIELDS: {
      return {
        ...state,
        paperfliteLoading: true,
        paperfliteError: null
      };
    }

    case FETCHING_PAPERFLITE_CUSTOM_FIELDS_SUCCEEDED: {
      const record = action.payload;

      return {
        ...state,
        paperfliteLoading: false,
        paperfliteFields: record
      };
    }

    case FETCHING_PAPERFLITE_CUSTOM_FIELDS_FAILED: {
      var error = action.payload;

      return {
        ...state,
        loading: false,
        paperfliteError: error
      };
    }

    case FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC: {
      return {
        ...state,
        loading: true,
        paperfliteError: null
      };
    }

    case FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_SUCCEEDED: {
      const record = action.payload;

      return {
        ...state,
        loading: false,
        paperfliteSync: record
      };
    }

    case FETCHING_PAPERFLITE_CUSTOM_FIELDS_SYNC_FAILED: {
      var error = action.payload;

      return {
        ...state,
        loading: false,
        paperfliteError: error
      };
    }

    case CREATE_CUSTOM_FIELD: {
      return {
        ...state,
        creating: true
      }
    }
  
    case CREATING_CUSTOM_FIELD_SUCCEEDED: {
      const record = action.payload.response;

      let items = state.items;
      items = [...state.items, record];
  
      return {
        ...state,
        creating: false,
        invalidated: false,
        items: items,
        currentField: record
      }
    }
  
    case CREATING_CUSTOM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        creating: false,
        invalidated: false,
        error: error
      }
    }

    case CREATE_CUSTOM_FIELD_FROM_PAPERFLITE: {
      return {
        ...state,
        updating: true
      }
    }

    case CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_SUCCEEDED: {
      const record = action.payload.response;
      const filteredItems = state.items.filter(item => item.id);
      const updatedItems = [...filteredItems, ...record];

        return {
          ...state,
          updating: false,
          invalidated: false,
          items: updatedItems,
          currentField: record[0]
        };
    }

    case CREATING_CUSTOM_FIELD_FROM_PAPERFLITE_FAILED: {
      var error = action.payload;

      return {
        ...state,
        updating: false,
        invalidated: false,
        error: error
      }
    }

    case UPDATE_CUSTOM_FIELD: {
      return {
        ...state,
        updating: true,
        invalidated: true
      }
    }
  
    case UPDATING_CUSTOM_FIELD_SUCCEEDED: {
      const record = action.payload.response;

      let items = [...state.items].filter(item => item.id);
      items = items.map(item => item.id == record.id ? record : item);

      return {
        ...state,
        updating: false,
        invalidated: false,
        currentField: record,
        items: items
      }
    }
  
    case UPDATING_CUSTOM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        updating: false,
        invalidated: false,
        error: error
      }
    }

    case INVALIDATE_CUSTOM_FIELDS: {
      return {
        ...state,
        updating: false,
        invalidated: true,
        items: [],
        currentField: null,
        error: null
      }
    }

    default:
        return state;
  }
}

export { fieldsReducer };